import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { formKey } from '../../../@commons/utils/noun-phrase.util';
import { DayText } from './day-message.model';

/**
 * Le texte d'un message, dans la langue de l'app. La clé prend la variante de
 * son accord quand elle existe : `_one` au singulier, `_f` (ou `_n`) selon le
 * genre, puis les deux ensemble (`title_one_f`, « Ta mâche sera meilleure »).
 * Une phrase qui s'ouvre sur un nom prend sa majuscule (« tes poireaux » →
 * « Tes poireaux tiennent l'hiver dehors. »). Une clé absente laisse place à
 * son repli (`fallback`). Un texte déjà écrit par le serveur passe tel quel.
 */
export function renderDayText(translate: TranslateService, part: DayText | null | undefined): string {
  if (!part) return '';
  if (part.text != null) return part.text;
  if (!part.key) return '';
  const has = (key: string) => translate.instant(key) !== key;
  const key = formKey(part.key, part.form, has);
  if (part.fallback && !has(key)) return renderDayText(translate, part.fallback);
  const text: string = translate.instant(key, part.params);
  const opensOnName = String(translate.instant(key)).startsWith('{{');
  return opensOnName ? text.charAt(0).toLocaleUpperCase() + text.slice(1) : text;
}

/** `{{ message.title | vwDayText }}`. Impur, comme le pipe `translate`. */
@Pipe({ name: 'vwDayText', standalone: true, pure: false })
export class DayTextPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(part: DayText | null | undefined): string {
    return renderDayText(this.translate, part);
  }
}
